import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import CustomizedAccordions from "../../components/homepage/accordion";
import ContentCards from "../../components/homepage/contentCards";
import CustomContainer from "../../components/layout/container";
import CustomHeader from "../../components/layout/header";

import OBRweoEOlogos from "../../images/OBRefo_WEO_EO_PurpleHint.jpg"
import DASicon2019 from "../../images/DAS_icon_2019.png"
import FeedbackFaces from "../../images/FeedbackFaces_Red.jpg"



const DASCaseStudy = () => {
  const router = useNavigate();
  const [pageTitle, setPageTitle] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] =
    useState("why/case-study/DAS");

  const breadcrumbData = [
    { name: "Home", link: "/" },
    {
      name: `Case Study (DAS)`,
      link: `/why/case-study/DAS`,
    },
  ];

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={"Client Case Study-Consultancy"}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={OBRweoEOlogos}
                title="Client Profile - SME Consultancy"
                objectFit="contain"
                subTitle="Management Consultancy with Multinational Clients"
                //example to link in text
                body={`DAS are an independent management consultancy specialising in strategy, change, programme management, complex systems 
                engineering, data analytics and asset optimisation. They specialise in bridging the gap between strategy and operations, creating 
                effective solutions to uniquely complex issues faced by our clients worldwide. `}
              />
              <CustomizedAccordions
                title="DAS Service Offer"
                body={`DAS offer six complementary capabilities to help our client solve their most critical strategic and operational challenges:
              <ul>
              <li>Strategy/Policy</li>
              <li>Business Transformation/Change</li>
              <li>Project, Programme, Portfolio Management</li>
              <li>Business Intelligence & Data Analytics</li>
              <li>Asset Optimisation</li>
              <li>Cyber Security</li>
              </ul>
              `}
              />
              <CustomizedAccordions
                title="DAS's Needs"
                body={`DAS conduct regular analysis & forecasts of national Defence Spending procurement programmes using a <b>bottom-up "micro" approach</b>. 
                But to cross-check this domain-level methodology and ensure the analysis is coherent, DAS commissioned MEF to provide national Defence 
                Spending projections using a <b>“top-down” macro/global scenario approach</b> - this also enables sensitivity analysis to be conducted ie 
                exploring  & quantifying <a title='unexpected outcomes significantly impacting business/economic outcomes'> shocks </a>from official macroeconomic projections that impact Global/UK Defence Spending.`}
              />

            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={DASicon2019}
                title="Client Needs-Bespoke Model/Scenarios"
                objectFit="contain"
                subTitle={`Why DAS use MEF services - DEFMOD bespoke model`}
                body={`<p>Following initial consultation & research, MEF constructed a specialist forecast/scenario model of Global Defence 
                Spending <b>DEFMOD</b> powered by macroeconomic/other outputs from MEF's <a href='/how/mGEM-global-macro' title="macro Global Econometric Model">mGEM</a> model. Global/national scenario analysis (ie imposing "shocks")
                can then be conducted on mGEM with outputs fed into DEFMOD to derive domain-level, fully-consistent risk analysis 
                of national Defence Spending. The likely range of uncertainty in this key metric for DAS can then be identified & quantified for their own
                consultancy offer to clients. DEFMOD sensitivity analysis - crucial for DAS clients' strategic planning - is thus "globally-consistent" 
                and thus more robust.</p>`}
              />
              <CustomizedAccordions
                title="Bespoke Model-Building Process: DEFMOD"
                body={`This global model of Defence Spending in all major Defence nations (eg US, China, Russia, France, Germany, Turkey etc..) was assembled by MEF economists who
                have built/maintained the MEF suite of (structural) economic models. This latter knowledge allows them to propose the best structure for <i>client-owned</i> satelitte models - that focus on
                the client's core domain area (eg for DAS, National Defence procurement) - and the particular mGEM driver variables that will power such <a title="a model that does not feedback to the driver model"> recursive </a> client satellite models. 
                MEF sourced required data and then estimated a (structural) model of National Defence Spending <b>DEFMOD</b> typically driven by national factors (fiscal capacity, 
                demographic/social spending) and geopolitical factors (Defence Spending by non-friendly nations). <b>DEFMOD</b> covers all the major Defence Spending nations in 
                order to ensure that geo-political drivers are fully-specified; in essence, it captures the dynamics of any global arms race to ensure fully-consistent Defence Spending scenarios.
                Once operational, forecast scenario analysis can then be run on <b>DEFMOD</b> in a fully-coherent way given (global) macro drivers from mGEM scenario exercises.<br><br>
                `}
              />
              <CustomizedAccordions
                title="DEFMOD Scenario Analysis; using mGEM Scenario Drivers "
                body="Once deployed, DAS commission MEF to “stress-test” official (ie OBR, OECD, IMF) Budget projections with plausible global macro scenarios to capture & quantify 
                domain-level uncertainty around central projections; these are then fed-through to <b>DEFMOD</b> to quantify related uncertainties in possible Defence Spending outturns to 2040.
                DAS  typically conduct such mGEM-DEFMOD scenario update exercises with MEF after each major fiscal event in the UK; they can then pre-empt any potential deviations from the 
                official baseline forecast and its ramifications for Global/UK Defence Spending to 2040."
              />
              {/* Download not working ! + need .PDF icon
              <a href="./public/downloads/MEF_DAS_CaseStudy.pdf">    <button>Case Study .PDF</button> </a>  */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={FeedbackFaces}
                title="Client Feedback"
                objectFit="contain"
                subTitle={`On MEF services & how DEFMOD scenarios are used - DAS`}
                body={`<i>"..as a specialist consultancy we don’t run/maintain an in-house global macro global model but we do need to incorporate Global macro, [energy & geo-political] risk quantification in our own consultancy for clients. Many of these are large, globally-trading, multinational firms who are exposed to global/national risk at a fundamental level. MEF provides an agile & cost-effective way to incorporate such dimension of risk analysis (and mitigation) into our overall consultancy offer"</i><br><br>
                <hr style="color:#00a0a0;height:1px;width:50%;">
                If you would like to initiate an informal chat about how MEF's modelling and/or scenario services may augment your risk analysis, please email us
                at: <b style="color:#00a0a0" > bespoke@mef-uk.com </b> `}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default DASCaseStudy;
